import React from 'react';

const SocialMediaIcon = ({
    icon
}) => {
  return (
    <i className={`fa ${icon} w3-hover-opacity`} />

  );
}

export default SocialMediaIcon;
